module.exports = __webpack_public_path__ + "media/images/icon_comment-9f44fad3156adfbe747a7c9c42dd56d8.svg";